import {pushVJoySnackbar} from '@maltjoy/core-vue';

export function pushSuccessSnackBar(message: string) {
    pushVJoySnackbar({props: {message, level: 'success'}});
}

export function pushErrorSnackBar(message: string) {
    pushVJoySnackbar({props: {message, level: 'error'}});
}

export function pushWarningSnackbar(message: string) {
    pushVJoySnackbar({props: {message, level: 'warning'}});
}
